<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>car-electric</title><path d="M18.92 2C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2M6.5 12C5.67 12 5 11.33 5 10.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12M17.5 12C16.67 12 16 11.33 16 10.5S16.67 9 17.5 9 19 9.67 19 10.5 18.33 12 17.5 12M5 7L6.5 2.5H17.5L19 7H5M7 20H11V18L17 21H13V23L7 20Z" /></svg>
</template>

<style scoped>
path {
  stroke: rgb(var(--v-theme-primary));
  fill: rgb(var(--v-theme-primary));
}
</style>
